import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faPlug } from "@fortawesome/free-solid-svg-icons";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import ReactECharts from "echarts-for-react";


const Voltaware = () => {

    const [status, setStatus] = useState('NA');
    const [chartStatus, setChartStatus] = useState('NA');

    useEffect(() => {
        const controller = new AbortController();
        getVoltawareData();
        getChartData();

        return () => {
            controller.abort();
        };
    }, []);

    const getVoltawareData = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/voltaware/status', config);
            setStatus(resp.data);
        } catch(err) {
            toast.error('API error getting voltaware status, please refresh the page');
        }
    };

    const getChartData = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/voltaware/power-history', config);
            setChartStatus(resp.data);
        } catch(err) {
            toast.error('API error getting voltaware power history, please refresh the page');
        }
    };

    const  renderTimestamp = () => {
        if (status === 'NA') {
            return <div className="count" style={{fontSize: "175%", paddingBottom: "22px"}}>NA</div>;
        } else {
            let tsDate = new Date(status.data.server_timestamp);

            return <div className="count" style={{fontSize: "175%", paddingBottom: "22px"}}>{tsDate.toLocaleString()}</div>;
        }
    };

    const renderLastPower = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            let value = status.data.power.actualRaw / 1000;
            return <div className="count">{ value.toFixed(2) } kW</div>;
        }
    };

    const renderLastEnergy = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            let value = status.data.energy / 1000;
            return <div className="count">{ value.toFixed(2) } kWh</div>;
        }
    };

    const getVoltawareChartOption = () => {
        if (chartStatus === 'NA') {
            return;
        }

        var option = {
            title: {
                text: "Voltaware Power",
            },
            tooltip: {
                trigger: "axis",
            },
            legend: {},
            toolbox: {
                show: true,
                orient: 'vertical',
                left: 'right',
                top: 'center',
                feature: {
                    dataZoom: {},
                    dataView: { readOnly: false },
                    magicType: { type: ["line", "bar"] },
                    restore: {},
                    saveAsImage: {},
                },
            },
            xAxis: {
                type: "category",
                boundaryGap: false,
                // data: tsData,
                data: chartStatus.tsData,
                axisLabel: {
                    showMinLabel: false,
                }
            },
            yAxis: {
                type: "value",
                axisLabel: {
                    formatter: "{value} Wh",
                },
            },
            series: [
                {
                    name: "Power",
                    type: "line",
                    // data: powerData,
                    data: chartStatus.powerData,
                    markPoint: {
                        data: [
                            { type: "max", name: "Max" },
                            { type: "min", name: "Min" },
                        ],
                    },
                }
            ],
        };

        return option;
    };

    const renderVoltawareChart = () => {
        if (chartStatus === 'NA') {
            return;
        }

        return (
            <ReactECharts
                option={getVoltawareChartOption()}
                notMerge={true}
                lazyUpdate={true}
            />
        );
    };

    return (
        <div className="right_col" role="main">
            <header className="page-heading device-page-heading">
                <div>
                    <p className="eyebrow">CONNECTED DEVICE</p>
                    <h1>Voltaware</h1>
                </div>
            </header>
            <div className="row top_tiles">
                <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="tile-stats">
                        <h3>Timestamp</h3>
                        <div className="icon"><FontAwesomeIcon icon={faClock} size="3x" /></div>
                        { renderTimestamp() }
                    </div>
                </div>
                <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="tile-stats">
                        <h3>Last power</h3>
                        <div className="icon"><FontAwesomeIcon icon={faPlug} size="3x" /></div>
                        { renderLastPower() }
                    </div>
                </div>
                <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div className="tile-stats">
                        <h3>Today energy</h3>
                        <div className="icon"><FontAwesomeIcon icon={faBolt} size="3x" /></div>
                        { renderLastEnergy() }
                    </div>
                </div>
            </div>    
            
            <div className="clearfix"></div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="x_panel">
                        <div className="x_content">
                            <div id="voltaware-chart" className="device-chart">
                                { renderVoltawareChart() }
                            </div> 
                        </div>            
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Voltaware;
